import { Component, HostListener, OnInit } from '@angular/core';
import { SecretService } from '../../services/secret.service';

@Component({
    selector: 'supplystack-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent implements OnInit {

    public showCookieBanner = false;
    constructor(public secretService: SecretService) {}

    @HostListener('window:keyup.esc')
    onKeyUp() {
        this.dismissBanner();
    }

    ngOnInit() {
        this.showCookieBanner = !localStorage.getItem('acceptedCookies') && !this.secretService.getToken();
    }

    public dismissBanner() {
        localStorage.setItem('acceptedCookies', 'true');
        this.showCookieBanner = false;
    }

    public openPrivacyPolicy() {
        window.open('https://privacy-policy.operations.transporeon.com', '_blank');
    }
}
